import { Button, Text, VStack } from "@chakra-ui/react";
import {
  KYDAdminEventSummary,
  KYDEventBundle,
} from "@common/interfaces/KYDEvent";
import { Reorder, motion } from "framer-motion";
import BundleEvent from "./BundleEvent";

const MotionReorderGroup = motion(Reorder.Group);

const BundleEventsTable = ({
  loading,
  eventsInBundle,
  setEventsInBundle,
  isEditingEvents,
  setIsEditingEvents,
  onUpdateOrder,
  onUpdateBundle,
}: {
  loading: boolean;
  eventsInBundle: KYDAdminEventSummary[];
  setEventsInBundle: React.Dispatch<
    React.SetStateAction<KYDAdminEventSummary[]>
  >;
  isEditingEvents: boolean;
  setIsEditingEvents: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdateOrder: (order: string[]) => Promise<void>;
  onUpdateBundle: ({ events }: { events: string[] }) => Promise<void>;
}) => {
  const onDelete = (id: KYDAdminEventSummary["id"]) => {
    const events = eventsInBundle.filter((e) => e.id !== id);
    setEventsInBundle(events);
    onUpdateBundle({ events: events.map((e) => e.id) });
  };

  const setEventsInBundleFromOrder = (newOrder: string[]) => {
    setEventsInBundle(
      newOrder.map((id) => eventsInBundle.find((e) => e.id === id))
    );
  };

  return (
    <>
      {eventsInBundle.length ? (
        <MotionReorderGroup
          axis="y"
          onReorder={setEventsInBundleFromOrder}
          values={eventsInBundle.map((e) => e.id)}
          as="div"
          style={{
            listStyleType: "none",
            display: "table-row-group",
          }}
        >
          {eventsInBundle.map((eventInBundle) => {
            return (
              <BundleEvent
                onDragEnd={onUpdateOrder}
                key={eventInBundle.id}
                isDisabled={loading}
                onDelete={onDelete}
                isEditingEvents={isEditingEvents}
                id={eventInBundle.id}
                image={eventInBundle.image}
                link={"link" in eventInBundle ? eventInBundle.link : ""}
                name={eventInBundle.name}
                startAt={eventInBundle.display_start_at}
                venueName={eventInBundle.display_start_at}
              />
            );
          })}
        </MotionReorderGroup>
      ) : null}
      {!isEditingEvents && eventsInBundle.length === 0 ? (
        <VStack py={8}>
          <Text>No events were added to this bundle, yet.</Text>
          <Button onClick={() => setIsEditingEvents(true)}>Add events</Button>
        </VStack>
      ) : null}
    </>
  );
};

export default BundleEventsTable;
